
function isMobileDevice() {
  // Check the screen width to determine if it's a mobile device
  return window.innerWidth <= 768; // You can adjust the width as needed
}

if (isMobileDevice()) {
  const container = document.querySelector('.columns');

  // Get all the block elements
  const blocks = Array.from(container.querySelectorAll('.box'));
  
  // Sort the blocks based on their date values
  blocks.sort((a, b) => {
      const dateA = new Date(a.querySelector('.date').textContent);
      const dateB = new Date(b.querySelector('.date').textContent);
      return dateA - dateB;
  });
  
  // Clear the container
  container.innerHTML = '';
  
  // Append the sorted blocks back to the container
  blocks.forEach(block => {
      container.appendChild(block);
  });
  
}